import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

const SwitchButton = ({checked, name, onChange}) => {
    return (
        <label htmlFor={name} onClick={onChange} className="switch">
            <input name={name} type="checkbox" checked={checked} />
            <span className="slider round" />
        </label>
    );
};

SwitchButton.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired
};

export default withFormsy(SwitchButton);
